import React, { useState } from 'react';
// eslint-disable-next-line import/no-duplicates
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
// eslint-disable-next-line import/no-duplicates
import ClickHandler from '@nykaa/deals-utils/clicks';
import styled from '../../theme';
import IoElement from '../IOElement';
import { getDetailsClass, isTextVisible, isTitleFirst, isVideoType, } from './helpers';
import { handleRightClickCallback } from '../../helper';
import Iframe from '../Iframe';
const Wrapper = styled.div `
  text-decoration: none;
  color: inherit;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.22);
  display: block;
  background: white;
  cursor: pointer;
  @media ${(props) => props.theme.mq.md} { 
    &:hover {
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.3);
        -moz-box-shadow: 0 2px 12px 0 rgba(0,0,0,0.3);
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,0.3);
    }
  }
`;
const ContentWrapper = styled.div `
  border-radius: 4px;
  width: auto;
`;
const DetailsWrapper = styled.div `
  text-align: center;
  .titles-description {
    width: 100%;
    position: relative;
    border-radius: 0 0 3px 3px;
    background: #fff;
    word-wrap: break-word;
    padding: 10px 0;
    text-transform: capitalize;
    @media ${(props) => props.theme.mq.lg} { 
      padding: 12px 4px;
      height: 66px;
      width: auto;
    }
    .titles-wrap {
      @media ${(props) => props.theme.mq.md} { 
        font-size: 14px;
      }
      @media ${(props) => props.theme.mq.lg} { 
        font-size: 16px;
      }
    }
    .description {
      @media ${(props) => props.theme.mq.md} { 
        font-size: 13px;
      }
      @media ${(props) => props.theme.mq.lg} { 
        font-size: 15px;
      }
    }
  }
  .titles-description-sticky {
    border-radius: 3px;
    background:rgba(255,255,255, ${({ opacity }) => opacity || 1} );
    word-wrap: break-word;
    padding: 5px;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    max-width: 100%;
    width: auto;
    margin-right: 20px;
    margin-left: 20px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    bottom: 10px;
    text-transform: capitalize;

    @media ${(props) => props.theme.mq.md} { 
      padding: 16px 5px;
      height: 65px;
      width: auto;
    }

    @media ${(props) => props.theme.mq.lg} { 
      padding: 20px 5px;
      height: 85px;
      width: auto;
    }

    .titles-wrap {
      @media ${(props) => props.theme.mq.md} { 
        font-size: 14px;
      }
  
      @media ${(props) => props.theme.mq.lg} { 
        font-size: 18px;
      }
    }
    .description {
      @media ${(props) => props.theme.mq.md} { 
        font-size: 12px;
      }
  
      @media ${(props) => props.theme.mq.lg} { 
        font-size: 16px;
      }
    }
  }
  .titles-wrap {
    font-weight: 400;
    font-size: 4vw;
    line-height: 1.2;
    padding: 0 5px;

    .title-text{
      display: inline-block;

    }
    .discount-text {
      display: inline-block;
      color:  ${(props) => props.theme.brandPrimary};
      margin: 0 4px;
    }
  }
  .description {
    color: #3f414d;
  }
  .sub-description {
    color: #8c8d94;
  }
  .youtube-video-counts {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;
const YoutubeVideoLikes = styled.div `
  padding: 0 8px 0 0;
  font-size: 14px;
  color: #fc2779;
  vertical-align: middle;  
  .label {
    color: #8c8d94;
    margin-left: 2px;
  }

  &::before {
    content: '';
    background: url(https://adn-static1.nykaa.com/uploads/76207a80-64f6-4c5e-b89f-0fcde24d54f4.png) no-repeat;
    width: 14px;
    height: 14px;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
    margin-right: 3px;
    margin-top: -4px;
  }
`;
const YoutubeVideoViews = styled.div `
  padding: 0 8px 0 0;
  font-size: 14px;
  color: #fc2779;
  vertical-align: middle;  
  .label {
    color: #8c8d94;
    margin-left: 2px;
  }

  &::before {
    content: '';
    background: url(https://adn-static1.nykaa.com/uploads/27cff6f9-3c2e-47ca-9173-34e06a1f310b.png) no-repeat;
    width: 14px;
    height: 14px;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
  }
`;
const getTitleInOrder = (titleOrder, title, discountTitle) => {
    const spanElements = [];
    const discountElement = (discountTitle) && (React.createElement("span", { key: "discountTile", className: "discount-text" }, discountTitle));
    const titleElement = (title) && (React.createElement("span", { key: "palintitle", className: "title-text" }, title));
    if (isTitleFirst(titleOrder)) {
        spanElements.push(titleElement);
        spanElements.push(discountElement);
    }
    else {
        spanElements.push(discountElement);
        spanElements.push(titleElement);
    }
    return spanElements;
};
const displayIframe = (url) => (React.createElement(Iframe, { title: `${url}`, width: "100%", height: "100%", src: url, frameBorder: "0", allowFullScreen: true }));
const Banner = (widgetData) => {
    const [isIframe, setIframe] = useState(false);
    const { params, children, isServer, trackingData, isDesktop, isDevModeEnabled, devModeData, } = widgetData;
    const { appLinkData, appLinkType, url, title, discountTitle, titleOrder, textPosition, description, subDescription, textAreaOpacity, actionType, trackingParams, youtubeVideoViews, youtubeVideoLikes, } = params;
    const DetailsClass = getDetailsClass(textPosition);
    const showText = isTextVisible(params);
    const handleIntersect = () => {
        ImpressionsHandler.handleImpression(trackingData);
    };
    const handleIntersectV2 = () => {
        ImpressionsHandler.handleImpressionV2(trackingData);
    };
    const clickHandler = (event) => {
        event.preventDefault();
        if (!isVideoType(actionType)) {
            ImpressionsHandler.handleClick(trackingData)
                .finally(() => {
                /**
                 * ? Why finally?
                 * even in case of an error in handling impression...
                 * we would want the click to function as expected
                 */
                ClickHandler.handleClick({
                    appLinkData,
                    appLinkType,
                    trackingParams,
                    webActionType: actionType,
                    webActionUrl: url,
                    isDesktop,
                });
            });
        }
        else {
            setIframe(true);
        }
    };
    const exitCallBackHandler = () => {
        ImpressionsHandler.removeImpression(trackingData);
    };
    const devModeHandler = (!!isDevModeEnabled && {
        onContextMenu: () => handleRightClickCallback(devModeData),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(IoElement, { isServer: isServer, onIntersect: handleIntersect, exitCallBack: exitCallBackHandler, onIntersectV2: handleIntersectV2 },
            React.createElement(Wrapper, Object.assign({ onClick: clickHandler }, devModeHandler),
                React.createElement(ContentWrapper, null,
                    isIframe && (displayIframe(url)),
                    (!isIframe) && (children),
                    (showText) && (React.createElement(DetailsWrapper, { opacity: textAreaOpacity, isDesktop: isDesktop },
                        React.createElement("div", { className: DetailsClass },
                            React.createElement("div", { className: "titles-wrap" }, getTitleInOrder(titleOrder, title, discountTitle).map((span) => span)),
                            description && (React.createElement("div", { className: "description" }, description)),
                            subDescription && (React.createElement("div", { className: "sub-description" }, subDescription)),
                            (isDesktop && (youtubeVideoLikes || youtubeVideoViews)) && (React.createElement("div", { className: "youtube-video-counts" },
                                youtubeVideoViews && (React.createElement(YoutubeVideoViews, null,
                                    youtubeVideoViews,
                                    React.createElement("span", { className: "label" }, "Views"))),
                                youtubeVideoLikes && (React.createElement(YoutubeVideoLikes, null,
                                    youtubeVideoLikes,
                                    React.createElement("span", { className: "label" }, "Likes")))))))))))));
};
export default Banner;
